jQuery("body").ready(function ($) {
  if ($(".slider-tabs-section-mobile").length > 0) {
    $(".slider-tabs-section-mobile").slick({
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
    });
  }
  
  if ( $( '.slick-slider-companies-df' ).length > 0 ) {
    $( '.slick-slider-companies-df' ).slick( {
      dots: false,
      infinite: true,
      autoplay: false,
      autoplaySpeed: 4000,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $( '.testimony-icon-prev' ),
      nextArrow: $( '.testimony-icon-next' ),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
            prevArrow: false,
            nextArrow: false,
          },
        },
      ],
    } );
  }
});

